/*
 * This component is in charge of communciating with Google Analytics. It does not render anything,
 * but ensures the current active session (user, selected property) is send to GA, as well as navigation throughout the app
 */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

import session from 'containers/App/session';
import { GA_MEASUREMENT_ID, PROPERTY_ID_DIMENSION, USER_EMAIL_DIMENSION, USER_ID_DIMENSION } from './constants';

const GoogleAnalytics = () => {
    // useInjectSaga({ key: DOMAIN, saga });
    // eslint-disable-next-line no-unused-vars
    const location = useLocation();
    const propertyName = useSelector(session.selectors.selectPropertyName);
    const userDetails = useSelector(session.selectors.selectUserDetails);

    const userIDNumber = userDetails?.userId || 0;
    const userEmailAddress = userDetails?.email || 'Not set';
    const propertyNameString = propertyName || 'Not set';

    // Initialise GA session when component first mounted
    useEffect(() => {
        ReactGA.initialize(GA_MEASUREMENT_ID);
    }, []);

    useEffect(() => {
        const path = location.pathname;
        ReactGA.send({
            hitType: 'pageview',
            page: path,
            [USER_ID_DIMENSION]: userIDNumber,
            [USER_EMAIL_DIMENSION]: userEmailAddress,
            [PROPERTY_ID_DIMENSION]: propertyNameString,
        });
    }, [location]);

    return null;
};

export default GoogleAnalytics;
